export default "__VITE_ASSET__0a971b3c__"